import script from "./SvgSoftronLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./SvgSoftronLogo.vue?vue&type=script&setup=true&lang=js"

import "./SvgSoftronLogo.vue?vue&type=style&index=0&id=7b809089&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b809089"]])

export default __exports__